import actionTypes from '../constants/action-types';
import selectors from '../selectors';
import siteLocales from '../../site-locales';
import isFolderNameDuplicated from '../verifiers/is-folder-name-duplicated';

const foldersValidator = (store) => (next) => async (action) => {
  switch (action.type) {
    case actionTypes.ADD_FOLDER: {
      const { folderId, folderName, locale } = action.payload;
      const state = store.getState();
      const siteLocalesList = siteLocales.selectors.getSiteLocales(state);

      if (!siteLocalesList.includes(locale)) {
        console.error(`Current site does not have "${locale}" locale.`);
        return;
      }

      const targetFolder = selectors.getFolder(state, folderId);

      if (targetFolder) {
        console.error(`Folder with ID "${folderId}" already exists.`);
        return;
      }

      const folderNameDuplication = isFolderNameDuplicated(folderName, locale);

      if (folderNameDuplication) {
        console.error(`Folder with name "${folderName}" already exists in the "${locale}" locale.`);
        return;
      }

      next(action);
      break;
    }

    case actionTypes.DELETE_FOLDER: {
      const { folderId } = action.payload;
      const state = store.getState();
      const targetFolder = selectors.getFolder(state, folderId);

      if (!targetFolder) {
        console.error(`Folder with ID "${folderId}" does not exist.`);
        return;
      }

      next(action);
      break;
    }

    case actionTypes.RENAME_FOLDER: {
      const { folderId, folderName } = action.payload;
      const state = store.getState();
      const targetFolder = selectors.getFolder(state, folderId);

      if (!targetFolder) {
        console.error(`Folder with ID "${folderId}" does not exist.`);
        return;
      }

      const folderNameDuplication = isFolderNameDuplicated(folderName, targetFolder.locale);

      if (folderNameDuplication) {
        console.error(
          `Folder with name "${folderName}" already exists in the "${targetFolder.locale}" locale .`
        );
        return;
      }

      next(action);
      break;
    }

    case actionTypes.MOVE_TO_FOLDER: {
      const { itemId } = action.payload;
      const state = store.getState();
      const targetFolder = selectors.getFolder(state, itemId);
      const targetPage = selectors.getPage(state, itemId);

      if (!targetFolder && !targetPage) {
        console.error(`Item with ID "${itemId}" does not exist.`);
        return;
      }

      next(action);
      break;
    }

    default:
      next(action);
  }
};

export default foldersValidator;
